import { createContext, useContext, useEffect, useState } from "react";
import { getPlatformLinkByEnvironment } from "constants/platform-links";
import * as Sentry from "@sentry/nextjs";
import { MONDAY_AUTH_DOMAIN } from "constants/links";
import { getPlatformManifest, PLATFORM_MANIFEST_ASSETS_CDN_DOMAIN, PLATFORM_CDN_URL } from "./api-service";

export const PREFETCH_TYPES = {
  DNS_PREFETCH: "dns-prefetch",
  PREFETCH: "prefetch"
};

const SIGNUP_BACKGROUND_IMAGE_SRC =
  "https://dapulse-res.cloudinary.com/image/upload/v1658307867/monday_platform/signup/signup-background.png";
const SIGNUP_LOADER_IMAGE_SRC =
  "https://dapulse-res.cloudinary.com/image/upload/monday_platform/signup/loader_transparent_new.gif";

const STATIC_ASSETS_HREFS = [SIGNUP_BACKGROUND_IMAGE_SRC, SIGNUP_LOADER_IMAGE_SRC];

const MANIFEST_PREFETCHED_ASSET_KEYS = [
  "soft_signup.js",
  "soft_signup.css",
  "main.js",
  "main.css",
  "components.js",
  "components.css",
  "vendors.js",
  "vendors.css",
  "backbone_init.js",
  "backbone_init.css",
  "externals.js"
];

const PrefetchedSignupAssetsContext = createContext("PrefetchedSignupAssets");

export const PrefetchSignupAssetsProvider = (props) => {
  const { children } = props;
  const [prefetchedSignupAssetsLinks, setPrefetchedSignupAssetsLinks] = useState([]);

  useEffect(() => {
    const setData = async () => {
      const signupAssetsLinks = [];
      // auth dns prefetch
      signupAssetsLinks.push({
        type: PREFETCH_TYPES.DNS_PREFETCH,
        href: getPlatformLinkByEnvironment(MONDAY_AUTH_DOMAIN)
      });
      // static assets
      STATIC_ASSETS_HREFS.forEach((href) => {
        signupAssetsLinks.push({ type: PREFETCH_TYPES.PREFETCH, href });
      });
      const platformManifestUrl = PLATFORM_CDN_URL;

      try {
        getPlatformManifest().then((platformManifestResponse) => {
          if (platformManifestResponse.response) {
            const platformManifest = platformManifestResponse.response;
            // manifest dependant assets
            MANIFEST_PREFETCHED_ASSET_KEYS.forEach((key) => {
              if (platformManifest[key]) {
                signupAssetsLinks.push({
                  type: PREFETCH_TYPES.PREFETCH,
                  href: platformManifest[key].replace(PLATFORM_MANIFEST_ASSETS_CDN_DOMAIN, platformManifestUrl)
                });
              }
            });
            setPrefetchedSignupAssetsLinks(signupAssetsLinks);
          } else {
            Sentry.captureMessage(
              `getPlatformManifest() failed. Platform manifest response: ${JSON.stringify(platformManifestResponse)}`
            );
          }
        });
      } catch (e) {
        Sentry.captureException(e);
      }
    };

    setData();
  }, []);

  return (
    <PrefetchedSignupAssetsContext.Provider value={prefetchedSignupAssetsLinks}>
      {children}
    </PrefetchedSignupAssetsContext.Provider>
  );
};

export const usePrefetchedSignupAssets = () => {
  const prefetchedSignupAssetsLinks = useContext(PrefetchedSignupAssetsContext);

  return prefetchedSignupAssetsLinks;
};
